// extracted by mini-css-extract-plugin
export default {"header":"Contests_header__qorAf","contest":"Contests_contest__YyJ+Z","contestCard":"Contests_contestCard__N5oG2","contestCard__title":"Contests_contestCard__title__LiTCS"};